import { useEffect } from 'react';

interface IPreloadImageContainerProps {
    imageSrc: string;
}

const PreloadImageContainer = (props: IPreloadImageContainerProps) => {
    useEffect(() => {
        let preImg = document.createElement('link');
        preImg.href = props.imageSrc;
        preImg.rel = 'preload';
        preImg.as = 'image';
        document.head.appendChild(preImg);
        
        return () => {
            document.head.removeChild(preImg);
        }
    }, [props.imageSrc]);

    return null;
}

export default PreloadImageContainer;